<app-modal-shell
  [title]="'NAME_DATA.TITLE'"
  [cancelLabel]="'NAME_DATA.BUTTONS.CANCEL'"
  [saveLabel]="'NAME_DATA.BUTTONS.OK'"
  (cancelClicked)="cancel()"
  (saveClicked)="save()">

  <div class="form-group">
    <form [id]="'nameDetailsForm'" [formGroup]="form">
      <div class="row">
        <div class="col-12">
          <app-custom-input id="firstName" type="text"
                            [label]="'NAME_DATA.FIRSTNAME' | translate"
                            [customFormGroup]="form"
                            [noteText]="'NAME_DATA.FIELD_ERROR.REQUIRED' | translate"
                            data-cy="name-data-firstname"
          ></app-custom-input>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <app-custom-input id="lastName" type="text"
                            [label]="'NAME_DATA.LASTNAME' | translate"
                            [customFormGroup]="form"
                            [noteText]="'NAME_DATA.FIELD_ERROR.REQUIRED' | translate"
                            data-cy="name-data-lastname"
          ></app-custom-input>
        </div>
      </div>
    </form>
  </div>

</app-modal-shell>
